import { Routes } from '@angular/router';
import { AppRoute } from '@enums';
import {
    COMMUNITY_DETAILS_PAGE_OPTIONS,
    COMMUNITY_DETAILS_PAGE_ROUTES,
    OPENED_ENTITY_ID_PARAM_NAME
} from 'moddy/common';

export const COMMUNITIES_ROUTES: Routes = [
    {
        path: AppRoute.Communities.List,
        loadComponent: () => import('./list').then((m) => m.CommunitiesListPageComponent)
    },
    {
        path: `${AppRoute.Communities.Details}/:${OPENED_ENTITY_ID_PARAM_NAME}`,
        loadComponent: () => import('./details').then((m) => m.DetailsPageComponent),
        children: COMMUNITY_DETAILS_PAGE_ROUTES,
        providers: [
            {
                provide: COMMUNITY_DETAILS_PAGE_OPTIONS,
                useValue: {
                    communityListPageUrl: `/${AppRoute.Root.Communities}/${AppRoute.Communities.List}`
                }
            }
        ]
    },
    {
        path: '',
        redirectTo: AppRoute.Communities.List,
        pathMatch: 'full'
    }
];
